import axios from 'axios'
import config from './ambiente'
let querystring = require('querystring')


const baseUrl = config.apiUrlBase
// const relatorioUrlBase = config.relatorioUrlBase

const headerFormUrlEnconded = {
  // 'Content-Type': 'application/x-www-form-urlencoded'
}

//getValidarResposta(formularioId, perguntaId, codigoTipoResposta,valorResposta)
async function getValidarResposta(formularioId, perguntaId, codigoTipoResposta,valorResposta) {
  // let dados = {opcao: 'validarValorResposta', formularioId, perguntaId, resposta}
  const dados = {formularioId,perguntaId,codigoTipoResposta,valorResposta};
  var result = await axios.post(`${baseUrl}validacoes/resposta`, dados, headerFormUrlEnconded)
  let resultadoValidacao = result.data
  return resultadoValidacao
}

async function validarRespostaPorValor(respostaPerguntaValor){
  var result = await axios.post(`${baseUrl}validacoes/resposta/valor`, respostaPerguntaValor, headerFormUrlEnconded)
  let resultadoValidacao = result.data
  return resultadoValidacao
}

export default {
  getValidarResposta,
  validarRespostaPorValor
}



// WEBPACK FOOTER //
// ./src/services/PerguntaService.js